import _ from "lodash";
export default (state: tcpinpoint.Task[] = [], action: any) => {
	switch (action.type) {
		case "GET_TASKS_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Task[], state, "id");
		case "PUT_TASK_SUCCESS":
			return _.unionBy([action.resource as tcpinpoint.Task], state, "id");
		case "GET_TASK_SUCCESS":
			return _.unionBy([action.resource as tcpinpoint.Task], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
